import { useContext } from 'react';
import { TemplateListContext } from 'src/context/TemplateListContext';

export default function useTemplateListContext() {
  return useContext(TemplateListContext);
}
